// // component
// import SvgColor from '../../../components/svg-color';
// import categoryIcon from '../../../components/icons/dashboard.png';
// import dashboardIcon from '../../../components/icons/bar-chart (1).png';
// import brandIcon from '../../../components/icons/brand-icon.png'
// import productIcon from '../../../components/icons/box.png';
// import merchantIcon from '../../../components/icons/seller-icon.png';
// import user from '../../../components/icons/user.png';
// import buyer from '../../../components/icons/customer.png';

// // ----------------------------------------------------------------------

// const getNavConfig = (pathname) => {
//   let navConfig = [];

//   const role = sessionStorage.getItem('Role');
//   const userId = sessionStorage.getItem('UserId')
//   const isSeller = role === 'Seller';
//   const brandPathPattern = /^\/seller\/app\/[^/]+\/brand$/;

//   if (isSeller) {
//     if (brandPathPattern.test(pathname)) {
//       navConfig = [
//         {
//           title: 'dashboard',
//           path: '/seller/app',
//           icon: <img src={dashboardIcon} width="40%" />,
//         },
//         {
//           title: 'Products',
//           path: pathname.replace('/brand', '/product'),
//           icon: <img src={productIcon} width="40%" />,
//         },
//       ];
//     } else {
//       navConfig = [
//         {
//           title: 'dashboard',
//           path: '/seller/app',
//           icon: <img src={dashboardIcon} width="40%" />,
//         },
//         {
//           title: 'Brands',
//           path: '/seller/brands',
//           icon: <img src={brandIcon} width="40%" />,
//         },
//         {
//           title: 'Profile',
//           path: '/seller/profile',
//           icon: <img src={user} width="40%" />,
//         },
//       ];
//     }
//   } else {
//     navConfig = [
//       {
//         title: 'dashboard',
//         path: '/admin/app',
//         icon: <img src={dashboardIcon} width="40%" />,
//       },
//       {
//         title: 'Categories',
//         path: '/admin/categories',
//         icon: <img src={categoryIcon} width="30%" />,
//       },
//       {
//         title: 'Sellers',
//         path: '/admin/seller',
//         icon: <img src={merchantIcon} width="40%" />,
//       },
//       {
//         title: 'Brands',
//         path: '/admin/brands',
//         icon: <img src={brandIcon} width="40%" />,
//       },
//       {
//         title: 'Buyers',
//         path: '/admin/buyer',
//         icon: <img src={buyer} width="40%" />,
//       },
//     ];
//   }

//   return navConfig;
// };

// export default getNavConfig;

import categoryIcon from '../../../components/icons/dashboard.png';
import dashboardIcon from '../../../components/icons/bar-chart (1).png';
import brandIcon from '../../../components/icons/brand-icon.png';
import productIcon from '../../../components/icons/box.png';
import merchantIcon from '../../../components/icons/seller-icon.png';
import user from '../../../components/icons/user.png';
import buyer from '../../../components/icons/customer.png';

const getNavConfig = (pathname) => {
  let navConfig = [];

  const role = sessionStorage.getItem('Role');
  const userId = sessionStorage.getItem('UserId');
  const isSeller = role === 'Seller';
  const brandPathPattern = /^\/seller\/app\/[^/]+\/brand$/;
  console.log(pathname, 'dfakfudhfahufhaudsfhudsfhudahfuhdsuf');


  if (isSeller) {
    if (brandPathPattern.test(pathname)) {
      navConfig = [
        {
          title: 'dashboard',
          path: '/seller/app',
          icon: <img src={dashboardIcon} width="40%" />,
        },
        {
          title: 'Products',
          path: pathname.replace('/brand', '/product'),
          icon: <img src={productIcon} width="40%" />,
        },
      ];
    } else if (pathname?.includes('/seller/brand/')) {
      const pathParts = pathname.split('/');
      const brandId = pathParts[4];
      navConfig = [
        {
          title: 'dashboard',
          path: '/seller/app',
          icon: <img src={dashboardIcon} width="40%" />,
        },
        {
          title: 'Products',
          path: `/seller/brand/${brandId}/product`,
          icon: <img src={productIcon} width="40%" />,
        },
      ];
    } else {
      navConfig = [
        {
          title: 'dashboard',
          path: '/seller/app',
          icon: <img src={dashboardIcon} width="40%" />,
        },
        {
          title: 'Brands',
          path: '/seller/brands',
          icon: <img src={brandIcon} width="40%" />,
        },
        {
          title: 'Profile',
          path: '/seller/profile',
          icon: <img src={user} width="40%" />,
        },
      ];
    }
  } else {
    navConfig = [
      {
        title: 'dashboard',
        path: '/admin/app',
        icon: <img src={dashboardIcon} width="40%" />,
      },
      {
        title: 'Categories',
        path: '/admin/categories',
        icon: <img src={categoryIcon} width="30%" />,
      },
      {
        title: 'Sellers',
        path: '/admin/seller',
        icon: <img src={merchantIcon} width="40%" />,
      },
      {
        title: 'Brands',
        path: '/admin/brands',
        icon: <img src={brandIcon} width="40%" />,
      },
      {
        title: 'Buyers',
        path: '/admin/buyer',
        icon: <img src={buyer} width="40%" />,
      },
    ];
  }

  return navConfig;
};

export default getNavConfig;
